import React from 'react';
import { Box, Typography } from '@mui/material';
import AdminQuestionnaireManager from '../../admin/QuestionnaireManager';

/**
 * Questionnaire Manager component for managers
 * This is a wrapper around the admin QuestionnaireManager component
 * but placed within the audit section for managers
 */
const ManagerQuestionnaireManager = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Questionnaire Management
      </Typography>
      <Typography variant="body1" paragraph>
        Create and manage questionnaires that can be assigned to audit cases.
      </Typography>
      
      {/* Use the existing QuestionnaireManager component */}
      <AdminQuestionnaireManager />
    </Box>
  );
};

export default ManagerQuestionnaireManager;
